import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useCallback, useMemo } from "react";
import { Formik } from "formik";
import { useIntl } from "react-intl";
import { Box, Typography, Link, useMediaQuery } from "@material-ui/core";
import { SaveAlt } from "@material-ui/icons";
import { ProfileResource } from "@ploy-lib/rest-resources";
import { OverlayCircularProgress } from "@ploy-ui/core";
import { useResource } from "rest-hooks";
import useBuyoutStyles from "./BuyoutStyles";
import { BuyoutApplications } from "./components/BuyoutApplications";
import { BuyoutHeader } from "./components/BuyoutHeader";
import { fetchBuyoutData, exportBuyoutApplications } from "./endpoints/CoreBuyout";
import { messages } from "./messages";
import { useTenantImage } from "@ploy-ui/tenants";
import generateDownloadUrl from "./helpers";
import BuyoutBreadcrumbs from "./components/BuyoutBreadcrumbs";
import { clsx } from "clsx";
export function CoreBuyout() {
    const classes = useBuyoutStyles();
    const kristianThinkImage = useTenantImage("KristianThink");
    const [dataFetchSent, setDataFetchSent] = useState(false);
    const [buyoutData, setBuyoutData] = useState([]);
    const [searchVal, setSearchVal] = useState("");
    const [selectedId, setSelectedId] = useState();
    const [hasApplications, setHasApplications] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [exportUrl, setExportUrl] = useState(null);
    const intl = useIntl();
    const profile = useResource(ProfileResource.detail(), {});
    const getData = useCallback(() => {
        fetchBuyoutData()
            .then(res => {
            const contracts = res || [];
            setBuyoutData(contracts);
            setHasApplications(contracts.length > 0);
            setLoaded(true);
        })
            .catch((err) => {
            if (err.status === 403) {
                setError(intl.formatMessage(messages.noPermissionView));
            }
            else {
                setError(intl.formatMessage(messages.loadError));
            }
            setLoaded(true);
        });
    }, [intl]);
    useEffect(() => {
        if (!dataFetchSent) {
            setDataFetchSent(true);
            getData();
        }
    }, [dataFetchSent, getData]);
    const filteredApplications = useMemo(() => {
        return (buyoutData || []).filter((item) => {
            const matchesSearch = searchVal === "" ||
                item.AccountNumber?.includes(searchVal) ||
                item.ObjectSerialNumber?.toLowerCase().includes(searchVal.toLowerCase()) ||
                item.CustomerName?.toLowerCase().includes(searchVal.toLowerCase());
            const matchesId = selectedId === undefined || selectedId === "";
            return matchesSearch && matchesId;
        });
    }, [buyoutData, searchVal, selectedId]);
    const exportSyncKey = useMemo(() => {
        return filteredApplications.map(app => app.AccountNumber).join(",");
    }, [filteredApplications]);
    useEffect(() => {
        if (!loaded || filteredApplications.length === 0)
            return;
        async function fetchExportUrl() {
            const blob = await exportBuyoutApplications(filteredApplications);
            setExportUrl(generateDownloadUrl(blob));
        }
        fetchExportUrl();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exportSyncKey, loaded]);
    const isMobile = useMediaQuery("(max-width:600px)");
    const searchFilter = useCallback((val, id) => {
        setSearchVal(val);
        setSelectedId(id);
    }, []);
    return (_jsx(_Fragment, { children: loaded ? (error ? (_jsx(Box, { m: 4, children: _jsx(Typography, { color: "error", variant: "body1", children: error }) })) : (_jsxs(Box, { p: isMobile ? 1 : 4, style: {
                width: "100%",
                display: "flex",
                flexDirection: "column"
            }, children: [_jsx(BuyoutBreadcrumbs, { applicationNumber: undefined, application: undefined, includeContract: false }), _jsx(Formik, { initialValues: { id: profile.salespersonId }, onSubmit: () => { }, children: () => (_jsx(BuyoutHeader, { hasApplications: hasApplications, searchFilter: searchFilter })) }), hasApplications ? (_jsxs(_Fragment, { children: [_jsx(Box, { className: classes.exportBox, mb: 2, children: _jsxs(Link, { href: exportUrl ?? undefined, download: `Export_${new Date().toLocaleDateString()}.xlsx`, style: {
                                    display: "flex",
                                    alignItems: "center",
                                    textDecoration: "none",
                                    marginTop: isMobile ? 16 : 0
                                }, target: "_blank", rel: "noopener noreferrer", children: [_jsx(Typography, { variant: "body1", className: clsx(classes.link, classes.mediumLink), children: intl.formatMessage(messages.exportTable) }), _jsx(SaveAlt, { fontSize: "small", style: { marginLeft: 6, color: "#8734FF" } })] }) }), _jsx(BuyoutApplications, { applications: filteredApplications })] })) : (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "60%", marginLeft: isMobile ? "10%" : "50%", marginRight: isMobile ? "10%" : "0%", children: [_jsx("img", { src: kristianThinkImage ?? undefined, width: 159, height: 159, alt: "Kristian Think" }), _jsx(Typography, { variant: "body1", children: intl.formatMessage(messages.emptyStateText) })] }))] }))) : (_jsx(OverlayCircularProgress, { pending: !loaded })) }));
}
//# sourceMappingURL=CoreBuyout.js.map